<script>
import VueDatepickerLocal from "vue-datepicker-local";

export default {
  name: "DayPicker",
  components: {
    VueDatepickerLocal
  },
  data() {
    return {
      time: null,
      local: {
        dow: 7, // Monday is the first day of the week
        hourTip: "选择小时", // tip of select hour
        minuteTip: "选择分钟", // tip of select minute
        secondTip: "选择秒数", // tip of select second
        yearSuffix: "年", // format of head
        monthsHead: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ], // months of head
        months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), // months of panel
        weeks: "日_一_二_三_四_五_六".split("_"), // weeks
        cancelTip: "取消", // default text for cancel button
        submitTip: "提交" // default text for submit button
      }
    };
  },
  watch: {
    time() {
      this.$emit("getDay", this.time);
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" />
